import { AssessmentPositiveNegativeKinds, AssessmentRiskLevelSequence, } from 'constants/assessments';
import groupBy from 'lodash/groupBy';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { isGroupedKind, keyForGroupedKind } from '../constants';
export var useGroupedQuestionnaires = function (questionnaires) {
    var orderedQuestionnaires = useMemo(function () {
        return questionnaires.sort(function (a, b) {
            if (DateTime.fromJSDate(a.assessment.ended_at).hasSame(DateTime.fromJSDate(b.assessment.ended_at), 'day')) {
                // if same day, secondary sort by risk levels
                var aSequenceValue = AssessmentPositiveNegativeKinds.includes(a.kind)
                    ? a.results_sanitized.positive
                        ? 'positive'
                        : 'negative'
                    : a.results_sanitized.risk;
                var bSequenceValue = AssessmentPositiveNegativeKinds.includes(b.kind)
                    ? b.results_sanitized.positive
                        ? 'positive'
                        : 'negative'
                    : b.results_sanitized.risk;
                return (AssessmentRiskLevelSequence.indexOf(bSequenceValue) -
                    AssessmentRiskLevelSequence.indexOf(aSequenceValue));
            }
            else {
                return b.assessment.ended_at.getTime() - a.assessment.ended_at.getTime();
            }
        });
    }, [questionnaires]);
    var groupedQuestionnaires = useMemo(function () {
        return groupBy(orderedQuestionnaires, function (q) {
            return isGroupedKind(q.kind) ? keyForGroupedKind(q.kind) : q.kind;
        });
    }, [orderedQuestionnaires]);
    return groupedQuestionnaires;
};
